export const CAMPFIRE_HEAL_PER_SECOND = 2.4;

export function applyHealing(currentHp: number, maxHp: number, amount: number): number {
  if (amount <= 0 || currentHp >= maxHp) return Math.min(currentHp, maxHp);
  return Math.min(maxHp, currentHp + amount);
}

export function getVampirismHealing(damageDealt: number, vampirism: number): number {
  return Math.max(0, damageDealt) * Math.max(0, vampirism);
}

export function getRecoveryPerSecond(
  passiveRegen: number,
  nearCampfire: boolean,
  campfireHealPerSecond = CAMPFIRE_HEAL_PER_SECOND,
): number {
  return Math.max(0, passiveRegen) + (nearCampfire ? Math.max(0, campfireHealPerSecond) : 0);
}
